import React from 'react';

import styles from './ProductPurchaseCard.m.sass';

import ChannelImage from '../../../containers/channelUtils/ChannelImage';
import Button from '../../button/Button';
import Pricing from '../../pricing/Pricing';
import RadioGroupVariantPicker from '../variantPickers/RadioGroupVariantPicker';
import DropdownVariantPicker from '../variantPickers/DropdownVariantPicker';
import ProductOptionsPicker, {applyOptions} from '../ProductOptionsPicker';
import ProductPurchaseOccurrence from '../ProductPurchaseOccurrence';
import QuantityPicker from '../quantityPicker/QuantityPicker';

export default class ProductPurchaseCard extends React.PureComponent {
  static defaultQuantity = 1;

  componentWillMount() {
    this.updateOptions([]);
  }

  componentWillReceiveProps(nextProps) {
    const {selectedVariant, purchaseParams} = nextProps;

    if (selectedVariant !== this.props.selectedVariant) {
      return this.updateOptions([], purchaseParams.quantity, selectedVariant.price, selectedVariant.originalPrice);
    }
  }

  updateOptions = (
    selectedOptions,
    quantity = ProductPurchaseCard.defaultQuantity,
    price = this.props.selectedVariant.price,
    originalPrice = this.props.selectedVariant.originalPrice
  ) => {
    const {selectedVariant, onChange} = this.props;
    const options = (selectedVariant.optionSet && selectedVariant.optionSet.options) || [];

    const appliedOptions = options.filter(it => selectedOptions.includes(it.id));

    const totalCost = applyOptions(price, quantity, appliedOptions);

    let originalTotalCost;
    if (originalPrice) {
      originalTotalCost = applyOptions(originalPrice, quantity, appliedOptions);
    }

    this.setState({
      selectedOptions,
      totalCost,
      originalTotalCost,
    });

    onChange({
      purchaseParams: {
        options: selectedOptions,
        quantity: quantity,
      }
    });
  };

  updateQuantity = quantity => this.updateOptions(this.state.selectedOptions, quantity);

  render() {
    const {product, occurrences, selectedVariant, purchaseParams, eventParams, onChange, onPurchase} = this.props;
    const {selectedOptions, totalCost, originalTotalCost} = this.state;

    const options = (selectedVariant.optionSet && selectedVariant.optionSet.options) || [];

    return (
      <div className={styles.productCardWrapper}>
        <div className={styles.productCard}>
          <div className={styles.productCard_image}>
            <ChannelImage src={product.images[0]} alt={product.name}/>
          </div>

          {(occurrences && !!occurrences.length) && (
            <ProductPurchaseOccurrence
              occurrences={occurrences}
              selectedVariant={selectedVariant}
              eventParams={eventParams}
              onChange={eventParams => onChange({eventParams})}
            />
          )}

          {product.variants.length > 1 && (
            <div className={styles.productCard_group}>
              <div className={styles.productCard_options}>
                {product.variantSelectionWidget === 'radio_buttons' ? (
                  <RadioGroupVariantPicker
                    availableVariants={product.variants}
                    selectedVariant={selectedVariant}
                    onChange={selectedVariant => onChange({selectedVariant})}
                  />
                ) : (
                  <DropdownVariantPicker
                    availableVariants={product.variants}
                    selectedVariant={selectedVariant}
                    onChange={selectedVariant => onChange({selectedVariant})}
                  />
                )}
              </div>
            </div>
          )}

          {!!(selectedVariant.optionSet && selectedVariant.optionSet.options && selectedVariant.optionSet.options.length > 0) && (
            <div className={styles.productCard_group}>
              <div className={styles.productCard_options}>
                <ProductOptionsPicker
                  basePrice={selectedVariant.price}
                  quantity={purchaseParams.quantity}
                  availableOptions={options}
                  selectedOptionIds={selectedOptions}
                  onChange={this.updateOptions}/>
              </div>
            </div>
          )}

          <div className={styles.productCard_group}>
            <div className={styles.productCard_details}>
              <div className={styles.productCard_quantity}>
                <QuantityPicker
                  min={1}
                  max={99}
                  value={purchaseParams.quantity}
                  onChange={this.updateQuantity}
                />
              </div>

              <div className={styles.productCard_price}>
                <Pricing value={totalCost} originalValue={originalTotalCost} />
              </div>
            </div>

            <div className={styles.productCard_actions}>
              <Button full onClick={onPurchase}>Buy now</Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/productPurchase/productPurchaseCard/ProductPurchaseCard.js